function SouthAfrica({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2152)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M4.68628 27.314C-1.56209 21.0656 -1.56209 10.935 4.68628 4.68652C4.68584 4.68721 13.9131 16.0003 13.9131 16.0003L4.68628 27.314Z" fill="black"/>
  <path d="M13.913 16.0002L2.12204 8.03223C1.75648 8.66766 1.4341 9.33091 1.1571 10.0174L7.12641 16.0002L1.15729 21.9834C1.43404 22.6694 1.7561 23.3322 2.12142 23.9672L13.913 16.0002Z" fill="#FFDA44"/>
  <path d="M31.8646 13.9131H13.9127L4.68615 4.68652C3.6919 5.68077 2.82809 6.80521 2.12208 8.03215L10.0745 16L2.12146 23.9669C2.82746 25.1941 3.69165 26.319 4.68615 27.3135L13.9127 18.087H31.8646C31.9535 17.4038 32 16.7073 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131Z" fill="#6DA544"/>
  <path d="M6.25867 28.6922C8.95673 30.7661 12.334 31.9999 16 31.9999C23.3925 31.9999 29.6129 26.9861 31.4489 20.1738H14.7771L6.25867 28.6922Z" fill="#0052B4"/>
  <path d="M31.4489 11.8261C29.6129 5.01381 23.3925 0 16 0C12.334 0 8.95673 1.23381 6.25867 3.30769L14.777 11.8261H31.4489Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default SouthAfrica;
